export default "__VITE_ASSET__42262b00__"